module.exports = __webpack_public_path__ + "static/zh-logo100-web-white-98bee3ce841fe6140f2e73cf5deac32e.svg";